// @ts-nocheck
import {DeprecatedOldButton as Button} from '/ui/components/button/button';
import {Clickable} from '/ui/components/clickable/clickable';
import {yext} from '/ui/lib/msg';

import * as styles from '/ui/components/entitypicker/entitylist/itemlist.module.scss';

/**
 * @param {{
 *   onClick: function(): ?,
 * }} props
 * @returns {React.ReactElement}
 */
export const SeeMoreItem = ({
  onClick,
}) => {
  return (
    <Clickable tag="li" onClick={onClick} className={`${styles.item} ${styles.seeMoreItem}`}>
      <Button chromeless>{yext.msg('See More')}</Button>
    </Clickable>
  );
};
